module.exports = __webpack_public_path__ + "img/soprano_20s_aout_2021.c118d951.jpg";